import { uploadFileToCloudflare } from "./cloudflareUploadeImage";
import { uploadToFirebaseStorage } from "./firebaseUploadImages";

const is_firebase = true;

/**
 * Uploads an image to the specified storage (Firebase or Cloudflare).
 *
 * @param {File} file - The file to upload.
 * @param {(progress: number) => void} [onProgress] - Optional callback to track upload progress.
 * @param {boolean} [to_firebase=true] - Flag to determine the storage (true for Firebase, false for Cloudflare).
 * @param {string} [path='admin/uploads'] - The path where the file will be stored.
 * @returns {Promise<string>} - A promise that resolves to the file's download URL.
 * @throws {Error} - If the upload fails or no file is provided.
 */
export const imageUploader = async (
    file: File,
    onProgress?: (progress: number) => void,
    to_firebase: boolean = is_firebase ,
    path: string = 'admin/uploads'
): Promise<string> => {
    if (!file) {
        throw new Error("No file provided for upload.");
    }

    return to_firebase
        ? uploadToFirebaseStorage(file, onProgress,path)
        : uploadFileToCloudflare(file, onProgress);
};